import './Map.scss';

export { default } from './Map';
